import type { SxProps, Theme } from '@mui/material';

/**
 * The tag variant paints a transparent background and sets no text colour, so MUI's
 * `color="error"` leaves its white-on-red label on nothing and the pill reads empty.
 * The colour is carried here instead.
 */
export const errorTagSx: SxProps<Theme> = ({ backrs, typography }) => ({
  ...typography['text-xs-medium'],
  color: backrs.colors['Colors/Text/text-error-primary'],
  backgroundColor: 'transparent',
  border: `1px solid ${backrs.colors['Colors/Border/border-error']}`,
});
